/**
 * Libs
 */
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

/**
 * Components
 */
import PageMeta from 'src/components/organisms/page-meta';

/**
 * Constants
 */
import { PAGES_LOCALES } from 'src/constants/common.constants';
import { PrivacyContainer } from 'src/features/common/tech-pages/privacy-container';
import { TechPrivacyContainer } from 'src/features/white-labels/techcontemporary/tech-pages/privacy-container';
import { useGetUniverseTemplate } from 'src/hooks/use-get-universe-template';

const PrivacyPage = () => {
    const { isTechContemporary } = useGetUniverseTemplate();
    return (
        <>
            <PageMeta title="Privacy Policy" />
            {isTechContemporary ? <TechPrivacyContainer /> : <PrivacyContainer /> }
        </>
    );
};



// @ts-ignore
export const getServerSideProps = async ({ locale }) => ({
    props: {
        ...(await serverSideTranslations(locale, PAGES_LOCALES)),
    },
});

export default PrivacyPage;
